<span #content class="phx-tag-content" phx-tooltip phx-tooltip-on-truncate [phxContent]="content.textContent?.trim()">
  <ng-content></ng-content>
</span>
<i
  *ngIf="phxSuffixIcon"
  phx-icon
  color="currentColor"
  [phxIcon]="phxSuffixIcon"
  [size]="phxSize === 'large' || phxSize === 'medium' ? 20 : 16"
></i>
